var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['Content-Detail', _vm.cp_show_border && 'show-border']},_vm._l((_vm.list),function(item,index){return _c('articleContent',{key:index,attrs:{"from":"home","art-content":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }